import { ApplicationConfig } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideRepositories } from '../data/repositories';
import { provideApi } from '../data/api';
import { provideServices } from '../data/services';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const OtwPreset = definePreset(Aura, {
  theme: 'light',
  semantic: {
    primary: {
      50: '#E8F7ED',
      100: '#C4EBD4',
      200: '#8FD9B2',
      300: '#4CBF7D',
      400: '#007E33',
      500: '#0A7538',
      600: '#147E3A',
      700: '#186B37',
      800: '#165325',
      900: '#0F3D1D',
      950: '#082712',
    },
  },
  components: {
    drawer: {
      colorScheme: {
        light: {
          content: {
            padding: 0,
          },
        },
        dark: {
          content: {
            padding: 0,
          },
        },
      },
    },
    dataview: {
      colorScheme: {
        light: {
          header: {
            padding: 0,
          },
        },
        dark: {},
      },
    },
    // skeleton: {
    //   colorScheme: {
    //     light: {
    //       background: '{primary.300}',
    //       animation: {
    //         background: '{primary.200}',
    //       },
    //     },
    //   },
    // },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideApi(),
    provideServices(),
    provideRepositories(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: OtwPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
  ],
};
